import React from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { SyntheticEvent, useContext, useState } from "react";
import ConsolidationCommission from "./consolidation/ConsolidationCommission";
import CommissionCommerciauxGrc from "./commerciauxEtGrc/CommissionCommerciauxGrc";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const yearsToDisplayCommission = [new Date().getFullYear(),new Date().getFullYear() -1];

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography sx={{ color: "#fff" }}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MainCommission = () => {
  const [value, setValue] = useState<number>(0);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: "100%", mt: -3.5 }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              ".css-1bfa1cn-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                color: "#FC8404",
              },
              ".MuiTabs-fixed": {
                position: { xs: "fixed", sm: "fixed", md: "absolute" },
              },
              ".MuiTabs-flexContainer": {
                bgcolor: "#080d24",
                zIndex: 1000,
                pt: 3,
              },
            }}
            TabIndicatorProps={{ sx: { bgcolor: "#FC8404" } }}
          >
            <Tab
              label="Consolidation"
              {...a11yProps(0)}
              sx={{ color: "#fff", textTransform: "none" }}
            />
            <Tab
              label="Détail par article"
              {...a11yProps(1)}
              sx={{ color: "#fff", textTransform: "none" }}
            />
          </Tabs>
        </Box>

        <br></br>
        <br></br>
        <CustomTabPanel value={value} index={0}>
            <ConsolidationCommission />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
            <CommissionCommerciauxGrc />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default MainCommission;
